import { IconButton, InputAdornment } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { Dispatch, SetStateAction, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import theme from 'lib/theme'
import { useTranslation } from 'react-i18next'
import { BlueSearchIcon, SearchField, SearchIcon } from './SearchBar.styled'

type SearchBarProps = {
  input: string
  setInput: Dispatch<SetStateAction<string>>
  placeholderText: string
  handleClick: (query: string) => void
  ariaLabel: string
  width?: string
}

export const SearchBar = ({
  input,
  setInput,
  placeholderText,
  handleClick,
  ariaLabel,
  width,
}: SearchBarProps) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [focus, setFocus] = useState(false)
  const [hover, setHover] = useState(false)

  const clearSearch = () => {
    setInput('')
    navigate('/place')
  }

  const handleSearch = () => {
    if (input && input.length !== 0) {
      handleClick(input)
      setFocus(true)
    } else {
      clearSearch()
    }
  }

  return (
    <div>
      <SearchField
        width={width}
        autoFocus={Boolean(input)}
        onMouseOver={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        hover={hover}
        value={input}
        id='outlined-basic'
        placeholder={placeholderText}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleSearch()
          }
        }}
        helperText={
          input && input.length < 3 && focus
            ? 'Enter at least three characters'
            : ' '
        }
        onChange={(e) => setInput(e.target.value)}
        InputProps={
          focus
            ? {
                endAdornment: (
                  <InputAdornment position='end'>
                    {input && (
                      <IconButton
                        onMouseDown={clearSearch}
                        aria-label={t('clearSearch')}
                        sx={{
                          width: '52px',
                          height: '38px',
                          '&:hover': {
                            background: 'transparent',
                            color: theme.palette.action.hover,
                          },
                        }}>
                        <CloseIcon
                          sx={{
                            width: '20px',
                            height: '20px',
                            '&:hover': {
                              cursor: 'pointer',
                              background: 'transparent',
                            },
                          }}
                        />
                      </IconButton>
                    )}
                    <IconButton
                      onMouseDown={handleSearch}
                      aria-label={ariaLabel}
                      sx={{
                        width: '52px',
                        height: '38px',
                        '&:hover': { background: 'transparent' },
                      }}>
                      <BlueSearchIcon query={input} />
                    </IconButton>
                  </InputAdornment>
                ),
              }
            : {
                startAdornment: (
                  <InputAdornment position='start'>
                    <SearchIcon aria-hidden hover={hover} />
                  </InputAdornment>
                ),
              }
        }
      />
    </div>
  )
}
